import { isMobileViewPort, toggleBlockMenusById, toggleCurriculumListById } from './utils/utils';
/* JS to add click event listeners to `menu--ncea.html.twig`, `menu--subjects.html.twig` and
`menu--wahanga-ako.html.twig` */

/**
 * toggleBodyOverflow
 * ==================
 * Toggles body overflow to stop scrolling when megamenu is open.
 */
const toggleBodyOverflow = (className = 'overflow-hidden') => {
  document.body.classList.toggle(className);
};

/**
 * toggleSubjectNavs
 * ==================
 */
const toggleSubjectNavs = () => {
  // Reset body scroll to 0
  // This is required to ensure the custom top pos offset added for logged in users work.
  window.scrollTo(0, 0);

  toggleBodyOverflow();

  const blockIdNZCMenu = 'block-subjects';
  const blockIdNZCCurWideMenu = 'block-subjects-curriculum-wide';
  const blockIdTMOAMenu = 'block-wahangaako';
  const blockIdTMOACurWideMenu = 'block-wahangaako-curriculum-wide';
  const blockIdNCEAMenu = 'block-ncea';

  const menusWrapper = document.getElementsByClassName('menus-wrapper')[0];
  if (menusWrapper) {
    menusWrapper.classList.toggle('menus-wrapper--expanded-subjects');
  }

  toggleBlockMenusById([
    blockIdNZCMenu,
    blockIdNZCCurWideMenu,
    blockIdTMOAMenu,
    blockIdTMOACurWideMenu,
    blockIdNCEAMenu,
  ]);
};

/**
 * closeAllMegaMenus
 * =================
 * Close all open mega menus.
 */
const closeAllMegaMenus = (parentNav = null) => {
  const navs = document.querySelectorAll('.block-menu');
  navs.forEach((nav) => {
    if (!nav || nav !== parentNav) {
      nav?.classList?.remove('block-menu--expanded');
    }
  });
};

/**
 * toggleMenusWrapperBackdrop
 * ==========================
 * Toggles menus backdrop when megamenus are expanded.
 */
const toggleMenusWrapperBackdrop = (backdropThemeClass) => {
  const menusBackdrop = document.getElementsByClassName('menus-wrapper-backdrop')[0];
  if (menusBackdrop) {
    // Activate if any megamenus are expanded.
    const expandedMegamenus = document.getElementsByClassName('block-menu--expanded');
    if (expandedMegamenus.length) {
      document.body.classList.add('overflow-hidden-menus-backdrop');
      menusBackdrop.classList.add('menus-wrapper-backdrop--active');
      menusBackdrop.classList?.remove('menus-wrapper-backdrop--nzc');
      menusBackdrop.classList?.remove('menus-wrapper-backdrop--tmoa');
      menusBackdrop.classList.add(`menus-wrapper-backdrop--${backdropThemeClass}`);

      // Apply light backdrop for 'ncea' menu.
      const nceaMenu = document.getElementsByClassName('block-menu--expanded menu--ncea');
      if (nceaMenu.length) {
        menusBackdrop.classList.add('menus-wrapper-backdrop--light');
      } else {
        menusBackdrop.classList?.remove('menus-wrapper-backdrop--light');
      }
    } else {
      document.body.classList?.remove('overflow-hidden-menus-backdrop');
      menusBackdrop.classList?.remove('menus-wrapper-backdrop--active');
      menusBackdrop.classList?.remove('menus-wrapper-backdrop--light');
      menusBackdrop.classList?.remove('menus-wrapper-backdrop--nzc');
      menusBackdrop.classList?.remove('menus-wrapper-backdrop--tmoa');
    }
  }
};

/**
 * toggleParentMegamenu
 * ====================
 * Toggles parent megamenu when a megamenu inner toggle is clicked.
 */
const toggleParentMegamenu = (item) => {
  let backdropThemeClass;
  backdropThemeClass = item.classList.contains('menu-item-0--wahanga-ako-nav') ? 'tmoa' : '';
  backdropThemeClass = item.classList.contains('menu-item-0--nzc-nav') ? 'nzc' : '';
  backdropThemeClass = item.classList.contains('menu-item-0--ncea-nav') ? 'ncea' : '';

  const parentNav = item.closest('.block-menu');
  if (parentNav) {
    closeAllMegaMenus(parentNav);
    parentNav.classList.toggle('block-menu--expanded');
    toggleMenusWrapperBackdrop(backdropThemeClass);

    // Toggle [ New Zealand Curriculum - Curriculum Wide ] submenu.
    if (parentNav.id === 'block-subjects') {
      const parentNZCCurriculumWide = document.getElementById('block-subjects-curriculum-wide');
      if (parentNZCCurriculumWide) {
        if (parentNav.classList.contains('block-menu--expanded')) {
          parentNZCCurriculumWide.classList.add('block-menu--expanded');
        } else {
          parentNZCCurriculumWide.classList?.remove('block-menu--expanded');
        }
      }
    }

    // Toggle [ Te Marautanga o Aotearoa - Curriculum Wide ] submenu.
    if (parentNav.id === 'block-wahangaako') {
      const parentTMOACurriculumWide = document.getElementById('block-wahangaako-curriculum-wide');
      if (parentTMOACurriculumWide) {
        if (parentNav.classList.contains('block-menu--expanded')) {
          parentTMOACurriculumWide.classList.add('block-menu--expanded');
        } else {
          parentTMOACurriculumWide.classList?.remove('block-menu--expanded');
        }
      }
    }
  }
};

/**
 * addTabindexToMenuItems
 * ======================
 * Add tabindex to menu items.
 */
const addTabindexToMenuItems = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const topNavLinkClasses = [
      '.menu-item-0--subjects-nav',
      '.menu-item-0--wahanga-ako-nav',
      '.menu-item-0--ncea-nav',
    ];

    topNavLinkClasses.forEach((className) => {
      const topNavLink = document.querySelector(className);
      if (topNavLink) {
        topNavLink.setAttribute('tabindex', 0);
      }
    });
  });
};

/**
 * initMegamenuToggles
 * ===================
 * Add handlers to toggle megamenus.
 * Targets [ Level 0 / Index 1 ] list items.
 */
const initMegamenuToggles = () => {
  const items = document.querySelectorAll('.menu-item-0-1');
  if (items) {
    items.forEach((item) => {
      item.addEventListener('click', () => {
        // Add `click` handlers.
        if (!isMobileViewPort()) {
          toggleParentMegamenu(item);
        }
      });

      // Add `keydown` handlers.
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          toggleParentMegamenu(item);
        }
      });

      // Add `keydown` handlers.
      item.addEventListener('mouseup', () => {
        // Remove focus state on click.
        // This won't be needed once `:focus-visible` psuedo class is applied.
        // See NCEA-640 Tech Debt - Refactor focus state ...
        // See https://caniuse.com/?search=focus-visible for more info.
        item.blur();
      });
    });
  }
};

/**
 * initMobileLevel0Dropdowns
 * =========================
 * Add handlers to toggle level 0 dropdowns such as 'New Zealand Curriculum' and
 * 'Te Marautanga o Aotearoa' curriculum dropdowns.
 * Targets [ Level 0 ] items.
 */
const initMobileLevel0Dropdowns = () => {
  const curriculumNavIdNZC = 'subjects-nav';
  const curriculumNavIdTMOA = 'wahanga-ako-nav';
  const curriculumNavIdNCEA = 'ncea-nav';

  const menuListNZC = 'subjects-nav-menu-item-1-list';
  const menuListNZCCurWide = 'subjects-curriculum-wide-nav-menu-item-1-list';
  const menuListTMOA = 'wahanga-ako-nav-menu-item-1-list';
  const menuListTMOACurWide = 'wahanga-ako-curriculum-wide-nav-menu-item-1-list';
  const menuListNCEA = 'ncea-nav-menu-item-1-list';
  const menuListToggleClassName = 'menu-item-1-list--expanded';
  const calloutTitleToggleClassName = 'menu-item__callout-title--expanded';

  document.getElementById(curriculumNavIdNZC)?.addEventListener('click', (e) => {
    e.stopPropagation();

    if (isMobileViewPort()) {
      // Collapse TMOA curriculum menu and child learning areas, and NCEA menu.
      document
        .getElementById(curriculumNavIdTMOA)
        .querySelector('.menu-item__callout-title')
        ?.classList?.remove(calloutTitleToggleClassName);
      document.getElementById(menuListTMOA)?.classList?.remove(menuListToggleClassName);
      document.getElementById(menuListTMOACurWide)?.classList?.remove(menuListToggleClassName);
      document
        .getElementById(menuListTMOA)
        ?.classList?.remove('menu-item__callout-title--wahanga-ako-nav');

      document
        .getElementById(curriculumNavIdNCEA)
        .querySelector('.menu-item__callout-title')
        ?.classList?.remove(calloutTitleToggleClassName);
      document.getElementById(menuListNCEA)?.classList?.remove(menuListToggleClassName);
      document
        .getElementById(menuListTMOA)
        ?.classList?.remove('menu-item__callout-title--ncea-nav');

      e.target.classList.toggle(calloutTitleToggleClassName);
      toggleCurriculumListById([menuListNZC, menuListNZCCurWide]);
    }
  });

  document.getElementById(curriculumNavIdTMOA)?.addEventListener('click', (e) => {
    e.stopPropagation();

    if (isMobileViewPort()) {
      // Collapse NZC curriculum menu and child learning areas, and NCEA menu.
      document
        .getElementById(curriculumNavIdNZC)
        .querySelector('.menu-item__callout-title')
        ?.classList?.remove(calloutTitleToggleClassName);
      document.getElementById(menuListNZC)?.classList?.remove(menuListToggleClassName);
      document.getElementById(menuListNZCCurWide)?.classList?.remove(menuListToggleClassName);
      document
        .getElementById(menuListTMOA)
        ?.classList?.remove('menu-item__callout-title--subjects-nav');

      document
        .getElementById(curriculumNavIdNCEA)
        .querySelector('.menu-item__callout-title')
        ?.classList?.remove(calloutTitleToggleClassName);
      document.getElementById(menuListNCEA)?.classList?.remove(menuListToggleClassName);
      document
        .getElementById(menuListTMOA)
        ?.classList?.remove('menu-item__callout-title--ncea-nav');

      e.target.classList.toggle(calloutTitleToggleClassName);
      toggleCurriculumListById([menuListTMOA, menuListTMOACurWide]);
    }
  });

  document.getElementById(curriculumNavIdNCEA)?.addEventListener('click', (e) => {
    e.stopPropagation();

    if (isMobileViewPort()) {
      // Collapse NZC/TMOA curriculum menu and child learning areas.
      document
        .getElementById(curriculumNavIdNZC)
        .querySelector('.menu-item__callout-title')
        ?.classList?.remove(calloutTitleToggleClassName);
      document.getElementById(menuListNZC)?.classList?.remove(menuListToggleClassName);
      document.getElementById(menuListNZCCurWide)?.classList?.remove(menuListToggleClassName);
      document
        .getElementById(menuListTMOA)
        ?.classList?.remove('menu-item__callout-title--subjects-nav');

      document
        .getElementById(curriculumNavIdTMOA)
        .querySelector('.menu-item__callout-title')
        ?.classList?.remove(calloutTitleToggleClassName);
      document.getElementById(menuListTMOA)?.classList?.remove(menuListToggleClassName);
      document.getElementById(menuListTMOACurWide)?.classList?.remove(menuListToggleClassName);
      document
        .getElementById(menuListTMOA)
        ?.classList?.remove('menu-item__callout-title--wahanga-ako-nav');

      e.target.classList.toggle(calloutTitleToggleClassName);
      document.getElementById(menuListNCEA)?.classList?.toggle(menuListToggleClassName);
    }
  });
};

/**
 * initMobileLevel1Dropdowns
 * =========================
 * Add handlers to toggle level 1 dropdowns such as 'English' and 'The Arts' subject dropdowns.
 * Targets [ Level 1 ] items.
 */
const initMobileLevel1Dropdowns = () => {
  const items = document.querySelectorAll('.menu-item-1');
  items.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();

      if (isMobileViewPort()) {
        item.classList.toggle('menu-item-1--expanded');

        const childMenu = item.querySelector('.menu');
        if (childMenu) {
          childMenu.classList.toggle('menu--expanded');
        }
      }
    });
  });
};

/**
 * initMobileNavToggle
 * ===================
 * Add handler for mobile hamburger menu icon.
 */
const initMobileNavToggle = () => {
  const mobileNavBtn = document.getElementById('primary-menu-mob-nav-open');

  if (mobileNavBtn) {
    mobileNavBtn.addEventListener('click', () => {
      toggleSubjectNavs();
    });
  }

  const subjectsNavMobNavClose = document.getElementsByClassName('subjects-nav-mob-nav-close')[0];
  if (subjectsNavMobNavClose) {
    subjectsNavMobNavClose.addEventListener('click', () => {
      toggleSubjectNavs();
    });
  }
};

/**
 * initMobileNceaNavToggle
 * =======================
 * Add handler for mobile NCEA megamenu.
 */
const initMobileNceaNavToggle = () => {
  const nceaTopNav = document.getElementsByClassName('menu-item-0--ncea-nav')[0];
  if (nceaTopNav) {
    nceaTopNav.addEventListener('click', () => {
      if (isMobileViewPort()) {
        toggleBodyOverflow('overflow-hidden-ncea');

        const menuNcea = document.getElementsByClassName('menu--ncea')[0];
        if (menuNcea) {
          menuNcea.classList.toggle('block-menu--expanded');
        }
        const menusWrapper = document.getElementsByClassName('menus-wrapper')[0];
        if (menusWrapper) {
          menusWrapper.classList.toggle('menus-wrapper--expanded-ncea');
        }

        const nceaMobNavToggle = document.getElementsByClassName('menu-item-0--ncea-nav')[0];
        if (nceaMobNavToggle) {
          nceaMobNavToggle.classList.toggle('menu-item-0--expanded-ncea-nav');
        }
      }
    });
  }
};

/**
 * closeMenusWrapperBackdrops
 * ==========================
 * Close all menus' backdrops.
 */
const closeMenusWrapperBackdrops = () => {
  document.body.classList?.remove('overflow-hidden');
  document.body.classList?.remove('overflow-hidden-menus-backdrop');

  const menusBackdrop = document.getElementsByClassName('menus-wrapper-backdrop')[0];
  const menusWrapper = document.getElementsByClassName('menus-wrapper')[0];

  if (menusBackdrop) {
    menusBackdrop.classList?.remove('menus-wrapper-backdrop--active');
    menusBackdrop.classList?.remove('menus-wrapper-backdrop--light');
    menusBackdrop.classList?.remove('menus-wrapper-backdrop--nzc');
    menusBackdrop.classList?.remove('menus-wrapper-backdrop--tmoa');
  }

  if (menusWrapper) {
    menusWrapper.classList?.remove('menus-wrapper--expanded-subjects');
  }
};

/**
 * initCloseMenusOnResize
 * ======================
 * Event listener to close all mega menus on window resize.
 * This is necessary to ensure that our mobile/desktop interactions aren't interrupted.
 */
const initCloseMenusOnResize = () => {
  window.addEventListener(
    'resize',
    () => {
      closeAllMegaMenus();
      closeMenusWrapperBackdrops();
    },
    true
  );
};

/**
 * initJumpLinks
 * =============
 * Attach focus class on clicked jump link to retain focused state.
 */
const initJumpLinks = () => {
  const jumpLinks = document.querySelectorAll('.jump-links__item a');

  jumpLinks.forEach((jumpLink) => {
    jumpLink.addEventListener('click', (e) => {
      // Clear focused state of all links first.
      jumpLinks.forEach((jumpLinkItem) => {
        jumpLinkItem?.classList?.remove('jump-links__link--focused');
      });

      // Attach focused class to target link.
      e.target.classList.add('jump-links__link--focused');
    });
  });
};

/**
 * initHeadingLinks
 * =============
 * Attach focus class on clicked heading nav link to retain focused state.
 */
const initHeadingLinks = () => {
  const headingNavLinks = document.querySelectorAll('.heading-nav__link a');

  headingNavLinks.forEach((headingNavLink) => {
    headingNavLink.addEventListener('click', (e) => {
      // Clear focused state of all links first.
      headingNavLinks.forEach((headingNavLinkItem) => {
        headingNavLinkItem?.classList?.remove('heading-nav-link-focused');
      });

      // Attach focused class to target link.
      e.target.classList.add('heading-nav-link-focused');
    });
  });
};

export const initMenus = () => {
  initCloseMenusOnResize();
  initMegamenuToggles();
  initMobileLevel0Dropdowns();
  initMobileLevel1Dropdowns();
  initMobileNavToggle();
  initMobileNceaNavToggle();
  addTabindexToMenuItems();
  initJumpLinks();
  initHeadingLinks();
};

export default 'initMenus';
